<template>
  <validation-observer v-slot="{ invalid }" tag="div" class="modal-user-details">
    <h3>{{ tStatic('missingDetailsModalHeader') }}</h3>

    <div v-html="tStatic('missingDetailsModalText').replace('{name}', clientModel.user.name)"></div>

    <div class="input-column__container">
      <validation-provider v-slot="{errors}" rules="required" slim>
        <oie-base-input
          id="my-pages-first-name"
          v-model="details.firstName"
          :error-messages="errors"
          :label-text="`${tStatic('firstNameLabel')}*`"
          :placeholder="tStatic('firstNamePlaceholder')"></oie-base-input>
      </validation-provider>

      <validation-provider v-slot="{errors}" rules="required" slim>
        <oie-base-input
          id="my-pages-last-name"
          v-model="details.lastName"
          :error-messages="errors"
          :label-text="`${tStatic('lastNameLabel')}*`"
          :placeholder="tStatic('lastNamePlaceholder')"></oie-base-input>
      </validation-provider>

      <validation-provider v-slot="{errors}" rules="required|numeric" slim>
        <oie-base-input
          id="my-pages-user-number"
          v-model="userPhoneProxy"
          :label-text="`${tStatic('phoneLabel')}*`"
          :placeholder="tStatic('phonePlaceholder')"
          :max-length="27"
          :error-messages="errors"
          :prefix-value="activeCountry.callingCode"></oie-base-input>
      </validation-provider>

      <validation-provider
        v-if="isMultiUser && isUserAdmin"
        v-slot="{errors}"
        rules="required|numeric"
        slim>
        <oie-base-input
          id="my-pages-company-number"
          v-model="companyPhoneProxy"
          :error-messages="errors"
          :label-text="`${tStatic('phoneCompanyLabel')}*`"
          :placeholder="tStatic('phoneCompanyPlaceholder')"
          :prefix-value="activeCountry.callingCode">
        </oie-base-input>
      </validation-provider>

      <oie-action-wrapper>
        <oie-base-action theme="skeleton" @click="close">
          {{ tStatic('maybeLaterLabel') }}
        </oie-base-action>
        <oie-base-action :disabled="invalid" @click="save">
          {{ tStatic('genericSave') }}
        </oie-base-action>
      </oie-action-wrapper>
    </div>
  </validation-observer>
</template>

<script>
import utils from '@/core/utils'
import httpService from '@/core/http-service'

export default {
  data() {
    return {
      details: {
        firstName: '',
        lastName: '',
        userPhone: '',
        companyPhone: ''
      }
    }
  },
  computed: {
    activeCountry() {
      return this.clientModel.user.country
    },
    isMultiUser() {
      return this.clientModel.user.isMultiUser
    },
    isUserAdmin() {
      return this.clientModel.user.isUserAdmin
    },
    userPhoneProxy: {
      get() {
        return utils.extractPhoneNumberFromFormating(this.details.userPhone, this.activeCountry.callingCode)
      },
      set(val) {
        this.details.userPhone = utils.savePhoneNumberWithFormating(val, this.activeCountry.callingCode)
      }
    },
    companyPhoneProxy: {
      get() {
        return utils.extractPhoneNumberFromFormating(this.details.companyPhone, this.activeCountry.callingCode)
      },
      set(val) {
        this.details.companyPhone = utils.savePhoneNumberWithFormating(val, this.activeCountry.callingCode)
      }
    }
  },
  mounted() {
    // this.details.firstName = this.clientModel.user.firstName
    // this.details.lastName = this.clientModel.user.lastName
    this.details.userPhone = this.clientModel.user.userPhone
    this.details.companyPhone = this.clientModel.user.companyPhone
  },
  methods: {
    async save() {
      await httpService.post('auth/myMissingUserDetails', { ...this.details })

      // this is so that user name in header updates, could probably be done in a better way?
      this.clientModel.user.firstName = this.details.firstName
      this.clientModel.user.lastName = this.details.lastName

      this.publish('modal.hide.user-details')
    },
    close() {
      sessionStorage.setItem('userDetailsModalClosed', true)
      this.publish('modal.hide.user-details')
    }
  }
}
</script>

<style lang="scss">
.modal-user-details {
  display: flex;
  flex-direction: column;
  gap: measure(half);
}
</style>
